var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBigLkwb(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 725.55 694.18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".b2afd438-20f4-4ae6-b585-459c5047202e{fill:#0166a8;opacity:0.5;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Asset 7") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "acb73bc2-e799-4634-82db-7a416f8ad7cc",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "be736481-1edf-416e-b5cb-0cb2ff699257",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b2afd438-20f4-4ae6-b585-459c5047202e",
    d: "M127.5,0C109.05,17.18,97.68,41.42,89,66.7c-36.5,105.55,19.48,220.67,125,257.16a201.84,201.84,0,0,0,177.59-22.45,201.24,201.24,0,0,1,21.84-16.67c3.59-2.37,7.23-4.62,11-6.75A200.62,200.62,0,0,1,590.09,262.4c105,36.3,160.66,150.81,124.36,255.8a200.27,200.27,0,0,1-39.89,68.12C569.5,684.2,415.17,722.26,270,672.07,60.75,599.73-50.23,371.46,22.11,162.22A399.25,399.25,0,0,1,127.5,0Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBigLkwb);
export default __webpack_public_path__ + "static/media/big-lkwb.df1b2248502e804474adca667448abc7.svg";
export { ForwardRef as ReactComponent };